<template>
    <div>
        <div class="relative">
            <validation-provider :rules="rules" v-slot="{ errors }">
                <textarea
                    class="py-4 px-4 text-gray-400 border border-gray-300 w-full focus:border-blue-400 focus:outline-none h-32 text-lg lg:text-base"
                    :class="{ 'focus:border-red-400': errors[0], 'border-red-400': errors[0], 'bg-red-200': errors[0] }"
                    :id="inputHtmlId"
                    :value="value"
                    @input="updateValue($event.target.value)"
                    @change="changeValue($event.target.value)"
                    :rules="rules"
                    @keydown="keydown"
                ></textarea>
                <span v-if="errors[0]" class="text-sm text-red-400 mt-1">{{ errors[0] }}</span>
            </validation-provider>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import { ValidationProvider, extend } from 'vee-validate'
    import { required } from 'vee-validate/dist/rules'

    extend('required', {
        ...required,
        message: 'Det här fältet måste fyllas i'
    });

    export default {
        name: "CardTextarea",
        components: {ValidationProvider},
        props: {
            label: null,
            value: null,
            rules: {},
            limited: {
                default: false
            },
        },
        data() {
            return {
                inputHtmlId: _.uniqueId('card-input-')
            }
        },
        mounted() {
            setInterval(() => {
                this.$emit('change', this.value)
            }, 1000)
        },
        methods: {
            updateValue(value) {
                this.$emit('input', value)
            },
            changeValue(value) {
                this.$emit('change', value)
            },
            keydown(evt){
                if (this.limited) {
                    if ((evt.keyCode >= 48 && evt.keyCode <= 90) || evt.keyCode === 13) {
                        evt.preventDefault()
                        return
                    }
                }
            },
            // paste(e) {
            //     e.preventDefault()
            //     e.stopPropagation()
            //
            //     let paste = (e.clipboardData || window.clipboardData).getData('text/plain')
            //
            //     this.data += paste
            //     this.$emit('change', this.data)
            // }
        }
    }
</script>